<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="recursoCampanha?.nome | uppercase" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [autofocus]="autofocus"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="">NENHUM RECURSO</option>
        <option *ngFor="let recurso of recursos" [ngValue]="recurso.id" [disabled]="isSituacaoInativo(recurso.situacao)">{{recurso.nome | uppercase}}</option>
    </select>  
</ng-template>